export interface UrlList {
    project: string;
    link_sales: string;
    link_support: string;
    link_payment: string;
    link_portal: string;
}

export const ArrUrl: UrlList[] = [
    {
        project: 'bluehosting',
        link_sales: 'https://www.bluehosting.cl/contactar-con-ventas/',
        link_support: 'https://panel.bluehosting.host/submitticket.php?step=2&deptid=3',
        link_payment: 'https://panel.bluehosting.host/submitticket.php?step=2&deptid=3',
        link_portal:'https://haulmer.atlassian.net/servicedesk/customer/portal/1014',
    }, {
        project: 'openfactura',
        link_sales: 'https://www.openfactura.cl/contactar-con-ventas/',
        link_support: 'https://my.haulmer.com/submitticket.php?step=2&deptid=1',
        link_payment: 'https://my.haulmer.com/submitticket.php?step=2&deptid=5',
        link_portal:'https://haulmer.atlassian.net/servicedesk/customer/portal/1012',
    }, {
        project: 'chilefirmas',
        link_sales: 'https://www.chilefirmas.cl/contactar-con-ventas/',
        link_support: 'https://my.haulmer.com/submitticket.php?step=2&deptid=1',
        link_payment: 'https://my.haulmer.com/submitticket.php?step=2&deptid=5',
        link_portal:'',
    }, {
        project: 'haulmer',
        link_sales: 'https://www.haulmer.com/contactar-con-ventas/',
        link_support: 'https://my.haulmer.com/submitticket.php?step=2&deptid=1',
        link_payment: 'https://my.haulmer.com/submitticket.php?step=2&deptid=5',
        link_portal:'',
    }, {
        project: 'opencloud',
        link_sales: '/contactar-con-ventas/',
        link_support: 'https://panel.opencloud.host/submitticket.php?step=2&deptid=1',
        link_payment: 'https://panel.opencloud.host/submitticket.php?step=2&deptid=2',
        link_portal:'https://haulmer.atlassian.net/servicedesk/customer/portal/1014',
    }, {
        project: 'tuu',
        link_sales: 'https://www.tuu.cl/contactar-con-ventas/',
        link_support: 'https://my.haulmer.com/submitticket.php?step=2&deptid=1',
        link_payment: 'https://my.haulmer.com/submitticket.php?step=2&deptid=5',
        link_portal:'',
    },{
        project: 'maquinaazul',
        link_sales: 'https://www.maquinaazul.cl/contactar-con-ventas/',
        link_support: 'https://my.haulmer.com/submitticket.php?step=2&deptid=1',
        link_payment: 'https://my.haulmer.com/submitticket.php?step=2&deptid=5',
        link_portal:'',
    }
];

export class ProjectsUrl {

    constructor() {
    }

    getProjectList(project) {
        const activeProject = ArrUrl.filter(item => item.project === project)[0];
        return activeProject;
    }
}
